// extracted by mini-css-extract-plugin
export default {"wrapper":"HowItWorks_wrapper__we8o4","title":"HowItWorks_title__K9giQ","tabsList":"HowItWorks_tabsList__Pldz9","tab":"HowItWorks_tab__-PBJ7"};